import React from "react";
import { useAuth } from "../context/AuthContext";
import Subscribe from "../pages/Subscribe";
import { useLang } from "../context/LangContext";
import { Lock } from "lucide-react";

/**
 * PaywallGate: fully blocks the app ONLY when the current user's trial has
 * ended AND they are not paid. The check is fully SILENT — active/trial users
 * see no popup or notice at all. Only truly-expired users see the subscribe
 * screen (and even then, only after auth data is fully loaded to avoid a
 * flash of paywall on refresh).
 */
export default function PaywallGate({ children }) {
  const { user, loading } = useAuth();
  const { t } = useLang();

  // Still loading auth data → don't render paywall (avoids flash)
  if (loading || !user) return children;
  if (user.role === "admin") return children;
  // Explicit true = active (trial or paid). Missing/undefined = don't block.
  if (user.is_active !== false) return children;

  return (
    <div className="min-h-screen grain-bg" data-testid="paywall-overlay">
      <header className="glass-header sticky top-0 z-40">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2 font-semibold text-[#2A5948]">
            <Lock size={18} />
            <span className="text-lg">{t("brand")}</span>
          </div>
          <div className="text-xs text-[#5C6053]">{user?.name}</div>
        </div>
      </header>
      <div className="max-w-3xl mx-auto px-4 py-10">
        <div className="text-center mb-6">
          <h1 className="text-3xl font-semibold" data-testid="paywall-title">{t("access_expired_title")}</h1>
          <p className="mt-2 text-sm text-[#5C6053]">{t("access_expired_desc")}</p>
        </div>
        <div className="flex justify-center">
          <Subscribe embedded />
        </div>
      </div>
    </div>
  );
}
